define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../models/DocumentCategoryModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext, DocumentCategoryModel) {
    "use strict";
    var DocumentCategory = /** @class */ (function () {
        function DocumentCategory() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,DocumentCategory.Edit,DocumentCategory.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,DocumentCategory.Delete"));
            this.filterByAny = ko.observable('');
            this.editModel = ko.observable(new DocumentCategoryModel());
            this.permissionModelTable = ko.observableArray();
        }
        DocumentCategory.prototype.init = function () {
            var self = this;
            $("#page-title").text("Document Categories");
            tools.ajaxGet({
                url: '/DocumentCategory/GetLookupData',
                success: function (data) {
                    if (data.Success) {
                        self.documentCategoryLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.documentCategoryLookupList.GridStructures.DocumentCategoryStructure);
                    ko.applyBindings(self, document.getElementById('main-container'));
                    $('#contextLoader').hide();
                    $('#mainContext').show();
                }
            });
        };
        DocumentCategory.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblDocumentCategoryKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = '';
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.documentCategoryTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/DocumentCategory/GetDocumentCategory",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($('#documentcategory-toolbar-template').html()),
                    columns: columns
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.documentCategoryTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.documentCategoryTable.getGridData().dataSource.read();
            });
            $('#' + gridId + ' tbody').on('click', '.btn-edit', function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editDocumentCategory(data.Id);
                event.preventDefault();
            }).on('click', '.btn-remove', function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteDocumentCategoryConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        DocumentCategory.prototype.editDocumentCategory = function (id) {
            var self = this;
            var title = 'Add New File Group';
            if (!isNaN(id)) {
                title = 'Edit File Group';
            }
            tools.editModal({
                title: title,
                buttonTitle: 'Save',
                type: 'info',
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error('Group Name is required');
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.saveDocumentCategory(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: '/DocumentCategory/GetDocumentCategoryById',
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new DocumentCategoryModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new DocumentCategoryModel());
                    }
                    var getPermModelCall = null;
                    self.permissionModelTable.removeAll();
                    getPermModelCall = tools.ajaxPost({
                        url: '/DocumentCategory/GetDocumentPermissions',
                        data: { categoryId: id }
                    }).done(function (result) {
                        for (var i = 0; i < result.length; i++) {
                            self.permissionModelTable.push(result[i]);
                        }
                    });
                    $.when(getModelCall, getPermModelCall).done(function (data) {
                        $(modal).find('.modal-body').html("<div data-bind=\"template: { name: 'dc-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        $('#permissionType', modal).bind('change', function (e) {
                            if (self.editModel().Type() == 'private') {
                                $('#permissions', modal).show();
                            }
                            else {
                                $('#permissions', modal).hide();
                            }
                        }).trigger('change');
                    });
                }
            });
        };
        DocumentCategory.prototype.saveDocumentCategory = function (btn, modal) {
            var self = this;
            var data = {
                permissions: JSON.stringify(ko.mapping.toJS(self.permissionModelTable())),
                model: JSON.stringify(ko.mapping.toJS(self.editModel)),
            };
            data['__RequestVerificationToken'] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: '/DocumentCategory/SaveDocumentCategory',
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success('Changes updated successfully');
                    self.documentCategoryTable.refresh();
                    $(modal).modal('hide');
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button('reset');
            });
        };
        DocumentCategory.prototype.deleteDocumentCategory = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data['__RequestVerificationToken'] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/DocumentCategory/DeleteDocumentCategoryConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success('File Group deleted successfully');
                    self.documentCategoryTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        DocumentCategory.prototype.deleteDocumentCategoryConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: 'Delete File Group',
                text: 'Are you sure you want to delete file group ' + name + '?',
                buttonTitle: 'Delete',
                type: 'danger',
                modalOptions: {},
            }, function (modal) {
                $(modal).modal('hide');
                self.deleteDocumentCategory(id);
            });
        };
        return DocumentCategory;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith('/DocumentCategory/Index')) {
            log.log('Initialize Document Category list');
            $(function () {
                (new DocumentCategory()).init();
            });
        }
    }, 0);
    return DocumentCategory;
});
//# sourceMappingURL=documentCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/documentCategory/documentCategory.js
// module id = 279
// module chunks = 2